import { Sparkles, Camera, Monitor, Phone, MessageSquare, Crown } from "lucide-react";

const map = { Sparkles, Camera, Monitor, Phone, MessageSquare, Crown };

export default function ServiceIcon({ name, size = 22, className = "" }) {
  const C = map[name] || Sparkles;
  return <C size={size} strokeWidth={1} className={`text-gold ${className}`} />;
}
